// <s-sticky-buy>: mobile bar shown once the stable product-form host scrolls above the viewport.
// The bar's submit button targets the main product form via the form attribute, so add-to-cart stays native.
class SStickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.querySelector(this.dataset.target || '[data-product-form]');
    if (!target) return;
    this.#setVisible(false);

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.#setVisible(scrolledPast);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
    this.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
